<template>
	<router-view />
	<tip-modal></tip-modal>
</template>
<script>
import { TipModal } from '@/components';
export default {
	name: 'App',
	components: {
		TipModal,
	},
};
</script>
